const GO_ARENA_BLACK_COLOR = 1;
const GO_ARENA_BOARD_AREA = 81;
const GO_ARENA_BOARD_SIZE = 9;
const GO_ARENA_BUTTON_FEATURE_VALUE = 0.5;
const GO_ARENA_DEFAULT_EXPERIMENT_COUNT = 100;
const GO_ARENA_DEFAULT_OPENING_OFFSET = 0;
const GO_ARENA_DEFAULT_SEARCH_SIMULATION_COUNT = 0;
const GO_ARENA_EXPERIMENT_RENDER_INTERVAL = 4;
const GO_ARENA_GAME_OVER_PASS_COUNT = 2;
const GO_ARENA_KOMI_NORMALIZATION_POINTS = 15;
const GO_ARENA_KOMI_POINTS = 7;
const GO_ARENA_KATAGO_NAME = "KataGo b6c96";
const GO_ARENA_KATAGO_MODEL_URL = new URL("../../public/models/katago-b6c96.onnx", import.meta.url).href;
const GO_ARENA_KATAGO_VALUE_OUTPUT_COUNT = 3;
const GO_ARENA_KATAGO_WASM_URL = import.meta.env?.DEV ? "/teacher-runtime/" : null;
const GO_ARENA_MAXIMUM_MOVE_COUNT = 120;
const GO_ARENA_MAXIMUM_EXPERIMENT_COUNT = 100;
const GO_ARENA_MAXIMUM_OPENING_OFFSET = 1_000_000;
const GO_ARENA_MAXIMUM_SEARCH_SIMULATION_COUNT = 64;
const GO_ARENA_MINIMUM_PASS_MOVE_COUNT = 20;
const GO_ARENA_MINIMUM_EXPERIMENT_COUNT = 1;
const GO_ARENA_MINIMUM_OPENING_OFFSET = 0;
const GO_ARENA_MINIMUM_SEARCH_SIMULATION_COUNT = 0;
const GO_ARENA_MILLISECONDS_PER_SECOND = 1_000;
const GO_ARENA_NO_KO_MOVE = -1;
const GO_ARENA_OPENING_INDEX_MULTIPLIER = 17;
const GO_ARENA_OPENING_MOVE_COUNT = 4;
const GO_ARENA_OPENING_MOVE_MULTIPLIER = 31;
const GO_ARENA_OPENING_PAIR_SIZE = 2;
const GO_ARENA_OPPONENT_SEARCH_BRANCH_COUNT = 0;
const GO_ARENA_PASS_ALIVE_MAXIMUM_INTERNAL_POINT_COUNT = 1;
const GO_ARENA_PASS_ALIVE_REQUIRED_VITAL_REGION_COUNT = 2;
const GO_ARENA_PASS_MOVE = 81;
const GO_ARENA_PERCENT_MULTIPLIER = 100;
const GO_ARENA_PROBABILITY_DECIMAL_COUNT = 0;
const GO_ARENA_SEARCH_BATCH_SIZE = 1;
const GO_ARENA_SEARCH_PUCT_EXPLORATION = 1.5;
const GO_ARENA_RECENT_MOVE_COUNT = 5;
const GO_ARENA_MOKA_INPUT_PLANE_COUNT = 12;
const GO_ARENA_MOKA_MANIFEST_URL = new URL("../dist/arena/moka-model.json", import.meta.url).href;
const GO_ARENA_MOKA_NAME = "Moka";
const GO_ARENA_MOKA_WEIGHTS_URL = new URL("../dist/arena/moka-model.bin", import.meta.url).href;
const GO_ARENA_TEACHER_GLOBAL_FEATURE_COUNT = 14;
const GO_ARENA_TEACHER_SPATIAL_FEATURE_COUNT = 22;
const GO_ARENA_WHITE_COLOR = -1;
const GO_MODEL_BENCHMARK_INPUT_VALUE_COUNT = 810;
const GO_MODEL_BENCHMARK_ITERATION_COUNT = 100;
const GO_MODEL_BENCHMARK_MANIFEST_URL = new URL("../dist/arena/moka-model.json", import.meta.url).href;
const GO_MODEL_BENCHMARK_P50 = 0.5;
const GO_MODEL_BENCHMARK_P95 = 0.95;
const GO_MODEL_BENCHMARK_WARMUP_COUNT = 10;
const GO_MODEL_BENCHMARK_WEIGHTS_URL = new URL("../dist/arena/moka-model.bin", import.meta.url).href;
export { GO_ARENA_BLACK_COLOR, GO_ARENA_BOARD_AREA, GO_ARENA_BOARD_SIZE, GO_ARENA_BUTTON_FEATURE_VALUE, GO_ARENA_DEFAULT_EXPERIMENT_COUNT, GO_ARENA_DEFAULT_OPENING_OFFSET, GO_ARENA_DEFAULT_SEARCH_SIMULATION_COUNT, GO_ARENA_EXPERIMENT_RENDER_INTERVAL, GO_ARENA_GAME_OVER_PASS_COUNT, GO_ARENA_KOMI_NORMALIZATION_POINTS, GO_ARENA_KOMI_POINTS, GO_ARENA_KATAGO_MODEL_URL, GO_ARENA_KATAGO_NAME, GO_ARENA_KATAGO_VALUE_OUTPUT_COUNT, GO_ARENA_KATAGO_WASM_URL, GO_ARENA_MAXIMUM_MOVE_COUNT, GO_ARENA_MAXIMUM_EXPERIMENT_COUNT, GO_ARENA_MAXIMUM_OPENING_OFFSET, GO_ARENA_MAXIMUM_SEARCH_SIMULATION_COUNT, GO_ARENA_MINIMUM_PASS_MOVE_COUNT, GO_ARENA_MINIMUM_EXPERIMENT_COUNT, GO_ARENA_MINIMUM_OPENING_OFFSET, GO_ARENA_MINIMUM_SEARCH_SIMULATION_COUNT, GO_ARENA_MILLISECONDS_PER_SECOND, GO_ARENA_NO_KO_MOVE, GO_ARENA_OPENING_INDEX_MULTIPLIER, GO_ARENA_OPENING_MOVE_COUNT, GO_ARENA_OPENING_MOVE_MULTIPLIER, GO_ARENA_OPENING_PAIR_SIZE, GO_ARENA_OPPONENT_SEARCH_BRANCH_COUNT, GO_ARENA_PASS_ALIVE_MAXIMUM_INTERNAL_POINT_COUNT, GO_ARENA_PASS_ALIVE_REQUIRED_VITAL_REGION_COUNT, GO_ARENA_PASS_MOVE, GO_ARENA_PERCENT_MULTIPLIER, GO_ARENA_PROBABILITY_DECIMAL_COUNT, GO_ARENA_SEARCH_BATCH_SIZE, GO_ARENA_SEARCH_PUCT_EXPLORATION, GO_ARENA_RECENT_MOVE_COUNT, GO_ARENA_MOKA_INPUT_PLANE_COUNT, GO_ARENA_MOKA_MANIFEST_URL, GO_ARENA_MOKA_NAME, GO_ARENA_MOKA_WEIGHTS_URL, GO_ARENA_TEACHER_GLOBAL_FEATURE_COUNT, GO_ARENA_TEACHER_SPATIAL_FEATURE_COUNT, GO_ARENA_WHITE_COLOR, GO_MODEL_BENCHMARK_INPUT_VALUE_COUNT, GO_MODEL_BENCHMARK_ITERATION_COUNT, GO_MODEL_BENCHMARK_MANIFEST_URL, GO_MODEL_BENCHMARK_P50, GO_MODEL_BENCHMARK_P95, GO_MODEL_BENCHMARK_WARMUP_COUNT, GO_MODEL_BENCHMARK_WEIGHTS_URL };